// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"fcb41f523818ae2e2dd7","678":"ab6b75e40dd8bf1f5b53"}[chunkId] + ".js";
};